angular.module('impactx.osu').controller('OsuCtrl', ['$scope', 'dataGen', '$routeParams', '$window', '$mdDialog',
    'AppConfiguration', 'DeeplinkService', '$securityManager', '$redirect', OsuCtrl]);

function OsuCtrl($scope, dataGen, $routeParams, $window, $mdDialog, AppConfiguration, DeeplinkService, $securityManager, $redirect)
{
    $scope.currentYear = AppConfiguration.get('copyRightYear');
    $scope.removeCopyRight = AppConfiguration.get('removeCopyRight');

    $mdDialog.hide();
    if ($securityManager.isAuthorized()) {
        dataGen.getData({}, {osutan: $routeParams.tan}, "/osu/loggedinredirect").then(function (data) {
            if (data.data.osuredirect && !data.data.errorMessage) {
                $redirect.redirectTo(null, data.data.osuredirect);
            }
            else {
                $scope.errorMessage = data.data.errorMessage;
                $scope.osuredirect = data.data.osuredirect;
            }
        });
    }
    else {
        var hasMultipleExternalAuthorizations = AppConfiguration.get('hasMultipleExternalAuthorizations');
        var hasMultipleOpenIdAuthorizations = AppConfiguration.get('hasMultipleOpenIdAuthorizations');
        if (!hasMultipleExternalAuthorizations || hasMultipleOpenIdAuthorizations) {
            dataGen.getData({}, {osutan: $routeParams.tan}, "/osu/notloggedinredirect").then(function (data) {
                if (data.data.openId) {
                    DeeplinkService.storeOsuTan($routeParams.tan);
                }
                if (data.data.osuredirect && !data.data.errorMessage) {
                    $window.location.href = data.data.osuredirect;
                }
                else {
                    $scope.errorMessage = data.data.errorMessage;
                    $scope.osuredirect = data.data.osuredirect;
                }
            });
        }
        else {
            $redirect.redirectTo(null, '/chooseexternallogin/' + $routeParams.tan)
        }
    }
}